import { track } from '@vercel/analytics';

// 页面浏览事件
export const trackPageView = (page: string, authenticated: boolean) => {
  track('page_view', { 
    page, 
    authenticated,
    timestamp: new Date().toISOString()
  });
};

// 用户操作事件
export const trackUserAction = (action: string, data?: Record<string, any>) => {
  track('user_action', { 
    action, 
    ...data,
    timestamp: new Date().toISOString()
  });
};

// 社交媒体点击事件
export const trackSocialMediaClick = (platform: string, url: string) => {
  track('social_media_click', { 
    platform, 
    url,
    timestamp: new Date().toISOString()
  });
};

// 页面导航事件
export const trackNavigation = (from: string, to: string) => {
  track('navigation', { 
    from, 
    to,
    timestamp: new Date().toISOString()
  });
};

// 提示词相关事件
export const trackPromptAction = (action: 'create' | 'edit' | 'delete' | 'copy' | 'favorite', promptId?: string) => {
  const data: Record<string, string> = { 
    action,
    timestamp: new Date().toISOString()
  };
  
  if (promptId) {
    data.promptId = promptId;
  }
  
  track('prompt_action', data);
};

// 认证相关事件
export const trackAuthAction = (action: 'login' | 'logout' | 'register') => {
  track('auth_action', { 
    action,
    timestamp: new Date().toISOString()
  });
};

// 错误跟踪
export const trackError = (error: string, context?: string) => {
  const data: Record<string, string> = { 
    error,
    timestamp: new Date().toISOString()
  };
  
  if (context) {
    data.context = context;
  }
  
  track('error', data);
};

// 性能跟踪
export const trackPerformance = (metric: string, value: number, unit: string) => {
  track('performance', { 
    metric, 
    value, 
    unit,
    timestamp: new Date().toISOString()
  });
}; 